
import React from 'react'

function Discount({ amount, sign, showAuf = true }) {
  return (
    <>
        <div className="uk-flex-inline uk-flex-around uk-flex-bottom">
            <h1 style={{ fontSize: 48 }}>{amount} {sign} <span style={{ fontWeight: '300' }}>*</span></h1>
            {showAuf && <p style={{ fontSize: 32, marginLeft: '5px' }}>auf</p>}
        </div>
    </>
  )
}

export default Discount